const newborns = [
    {
        "no": "0001",
        "motherId": "A223456789",
        "medicalRecordNo": "AAB20210900091",
        "hospital": "0012",
        "motherName": "林小美",
        "newbornGender": "female",
        "birthday": "2020/01/21",
        "weight": "3000",
        "pregnantWeek": "40",
        "pregnantDay": "280",
        "labNo": "A1021",
        "screeningStatus": "pass",
        "sendUidDate": "2020/02/23",
        "reportDate": "2020/02/04",
        "diagnosisResult": "not detected",
        "createdOn": "2020/01/23"
    },
    {
        "no": "0002",
        "motherId": "A267891231",
        "medicalRecordNo": "AAB20210900191",
        "hospital": "0012",
        "motherName": "林小慧",
        "multipleBirth": ["Multiple Birth"],
        "birth": "B",
        "newbornGender": "male",
        "birthday": "2020/02/29",
        "weight": "2853",
        "pregnantWeek": "38",
        "pregnantDay": "266",
        "hearingScreening": "pass",
        "uid": "A00005",
        "collectionDate": "2020/03/01",
        "testDate": "2020/03/01",
        "createdOn": "2020/03/05"
    },
    {
        "no": "0003",
        "motherId": "A261191234",
        "medicalRecordNo": "AAB20210901191",
        "hospital": "0012",
        "motherName": "王美",
        "newbornGender": "male",
        "birthday": "2020/12/29",
        "weight": "2962",
        "pregnantWeek": "29",
        "pregnantDay": "273",
        "hearingScreening": "notPass",
        "uid": "A00105",
        "collectionDate": "2021/01/02",
        "testDate": "2021/01/03",
        "sendUidDate": "2021/01/01",
        "receiveUidDate": "2021/09/07",
        "screeningStatus": "pass",
        "createdOn": "2021/01/04"
    },
    {
        "no": "0004",
        "motherId": "A266291233",
        "medicalRecordNo": "AAB20210910291",
        "hospital": "0024",
        "motherName": "張家慧",
        "multipleBirth": ["Multiple Birth"],
        "birth": "C",
        "newbornGender": "female",
        "birthday": "2020/02/29",
        "weight": "2901",
        "pregnantWeek": "39",
        "pregnantDay": "275",
        "hearingScreening": "pass",
        "labNo": "B4892",
        "collectionDate": "2020/03/01",
        "receiveUidDate": "2020/04/01",
        "testDate": "2020/03/02",
        "screeningStatus": "undecidable",
        "createdOn": "2020/03/05"
    },
    {
        "no": "0005",
        "motherId": "A261896173",
        "medicalRecordNo": "AAB20210904291",
        "hospital": "0012",
		"motherName": "陳曉卿",
        "newbornGender": "male",
        "birthday": "2020/07/16",
        "weight": "3052",
        "pregnantWeek": "38",
        "pregnantDay": "269",
        "hearingScreening": "pass",
        "collectionDate": "2020/08/15",
        "receiveUidDate": "2020/09/01",
        "testDate": "2020/08/15",
        "sendUidDate": "2021/03/21",
        "screeningStatus": "undecidable",
        "createdOn": "2020/08/31"
    },
    {
        "no": "0006",
        "motherId": "A268569123",
        "medicalRecordNo": "AAB20210902591",
        "hospital": "0012",
		"motherName": "楊淑美",
        "newbornGender": "male",
        "birthday": "2020/05/19",
        "weight": "2819",
        "pregnantWeek": "38",
        "pregnantDay": "270",
        "hearingScreening": "pass",
        "uid": "A00657",
        "collectionDate": "2020/05/30",
        "testDate": "2020/06/01",
        "reportDate": "2020/07/21",
        "screeningStatus": "notPass",
        "createdOn": "2020/06/05"
    },
    {
        "no": "4821",
        "motherId": "A223448989",
        "medicalRecordNo": "AAB20210926041",
        "hospital": "0322",
		"motherName": "蕭小美",
        "newbornGender": "female",
        "birthday": "2020/11/21",
        "weight": "2890",
        "pregnantWeek": "40",
        "pregnantDay": "281",
        "labNo": "A1421",
        "reportDate": "2020/12/31",
        "createdOn": "2020/11/23"
    },
    {
        "no": "0013",
        "motherId": "A223123923",
        "medicalRecordNo": "AAB20210900492",
        "hospital": "0322",
		"motherName": "林章慧",
        "multipleBirth": ["Multiple Birth"],
        "birth": "B",
        "newbornGender": "male",
        "birthday": "2019/02/29",
        "weight": "2914",
        "pregnantWeek": "38",
        "pregnantDay": "271",
        "hearingScreening": "pass",
        "uid": "A32305",
        "collectionDate": "2019/03/01",
        "testDate": "2019/03/01",
        "receiveUidDate": "2019/04/23",
        "sendUidDate": "2018/12/31",
        "screeningStatus": "undecidable",
        "createdOn": "2019/03/05"
    },
    {
        "no": "0284",
        "motherId": "A261946234",
        "medicalRecordNo": "AAB20210923053",
        "hospital": "0012",
		"motherName": "王美瑧",
        "newbornGender": "male",
        "birthday": "2020/10/29",
        "weight": "3001",
        "pregnantWeek": "39",
        "pregnantDay": "279",
        "hearingScreening": "notPass",
        "uid": "A12105",
        "collectionDate": "2021/02/02",
        "receiveUidDate": "2020/02/03",
        "sendUidDate": "2020/02/03",
        "testDate": "2021/02/03",
        "screeningStatus": "pass",
        "createdOn": "2021/02/04"
    },
    {
        "no": "6204",
        "motherId": "A266286194",
        "medicalRecordNo": "AAB20210993291",
        "hospital": "0012",
		"motherName": "張小慧",
        "multipleBirth": ["Multiple Birth"],
        "birth": "B",
        "newbornGender": "female",
        "birthday": "2020/02/28",
        "weight": "3011",
        "pregnantWeek": "39",
        "pregnantDay": "275",
        "hearingScreening": "pass",
        "labNo": "B4064",
        "collectionDate": "2020/03/01",
        "receiveUidDate": "2020/04/02",
        "testDate": "2020/03/02",
        "createdOn": "2020/03/05"
    },
    {
        "no": "0245",
        "motherId": "A261904173",
        "medicalRecordNo": "AAB20210905481",
        "hospital": "0024",
		"motherName": "陳芝卿",
        "newbornGender": "female",
        "birthday": "2020/07/16",
        "weight": "2730",
        "pregnantWeek": "38",
        "pregnantDay": "266",
        "hearingScreening": "pass",
        "collectionDate": "2020/08/15",
        "testDate": "2020/08/15",
        "screeningStatus": "notPass",
        "createdOn": "2020/08/31"
    },
    {
        "no": "0016",
        "motherId": "A282069523",
        "medicalRecordNo": "AAB20210905042",
        "hospital": "0024",
		"motherName": "楊淑慧",
        "newbornGender": "male",
        "birthday": "2018/05/19",
        "weight": "2841",
        "pregnantWeek": "38",
        "pregnantDay": "267",
        "hearingScreening": "pass",
        "uid": "B02657",
        "collectionDate": "2018/08/20",
        "receiveUidDate": "2020/09/40",
        "testDate": "2018/8/21",
        "screeningStatus": "pass",
        "createdOn": "2018/08/21"
    }
];

export default newborns;